import { useEffect, useState } from 'react'
import {auth, quests} from '../services/api/models.ts';
import { useAuth0 } from '@auth0/auth0-react';
import { useAuthHelper } from './useAuthHelper';

const useQuestsAPI = (id , limit , skip , filter) => {
  const [isLoading, setLoading] = useState(true);
  const [data , setData] = useState([]);
  const [error , setError] = useState(null);
  const {isAuthenticated, loginWithRedirect , user} = useAuth0();
  const { getSafeAccessToken } = useAuthHelper();
  useEffect(()=>  {
    async function getData (){
    try {
      if(!isAuthenticated){
        await loginWithRedirect()
      }
      
      let accessToken = await getSafeAccessToken();
      
      // If token is null, redirect is happening
      if (!accessToken) {
        return; // Exit gracefully, redirect is happening
      }

      let headers = {Authorization: "Bearer "+ accessToken }
      let Options = {headers:headers} 
      if(id){
          let quest =  await quests.questsIdGet(id,Options)
          return quest.data
      }else{
        let questsList = await quests.questsGet(limit,skip,filter,Options)
         return questsList.data
      }
    } catch (err) {
      setError(err);
    }
  }

  getData().then((res)=>{
    setData(res || [])
  }).finally(()=>{
    setLoading(false);
  })
  
    
   
  },[id , skip , filter]);

  
  return {isLoading , data , error}
}

export default useQuestsAPI
